// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachment-modal-dark-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* Dark translucent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1999; /* Below the main modal content */
}

.attachment-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  background-color: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000; /* Ensure it's on top of everything */
}

.attachment-modal-content-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 90vw;
  max-height: 90vh;
}

.attachment-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.attachment-modal-close-btn {
  position: fixed;
  top: 15px;
  right: 10px;
  background-color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2001; /* Above the media content */
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}

.attachment-modal-close-btn i {
  color: black;
  font-size: 20px;
}

.attachment-modal-actions {
  position: fixed;
  top: 80px; /* Below the close button */
  right: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 2001;
}

.attachment-modal-action-btn {
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: background-color 0.2s ease;
}

.attachment-modal-action-btn i {
  color: #333;
  font-size: 18px;
}

.attachment-modal-react-icon {
  width: 20px;
  height: 20px;
  filter: grayscale(100%);
  opacity: 0.8;
}

.attachment-modal-emoji-picker-container {
  position: fixed;
  top: 210px;
  right: 50px;
  z-index: 2002; /* Above the modal overlay */
}

.attachment-modal-action-btn:hover {
  background-color: white;
}

.attachment-modal-media-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative; /* For positioning reactions */
  max-width: 100%;
  max-height: 100%;
}

.attachment-modal-media {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.attachment-modal-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align items to the left */
  text-align: left;
  margin-top: 16px;
  color: #333;
  width: 100%;
}

.attachment-modal-file-info {
  font-weight: bold;
  font-size: 16px;
  color: black;
}

.attachment-modal-view-btn {
  color: red;
  text-decoration: none;
}

.attachment-modal-view-btn:hover {
  opacity: 0.8;
}

.message-reactions.in-modal {
  position: absolute;
  bottom: 5px;
  left: -5px;
  z-index: 1;
}

.attachment-modal-fallback-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: #888;
  font-style: italic;
  font-size: 16px;
  width: 250px;
  height: 150px;
  border-radius: 8px;
  text-align: center;
}

.attachment-modal-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}

.attachment-modal-loading-text {
  font-size: 16px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/AttachmentPreviewModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC,EAAE,gCAAgC;EACtE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,iCAAiC;AAClD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa,EAAE,4BAA4B;EAC3C,4EAA4E;AAC9E;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS,EAAE,2BAA2B;EACtC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4EAA4E;EAC5E,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,aAAa,EAAE,4BAA4B;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB,EAAE,8BAA8B;EAClD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,4BAA4B;EACrD,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".attachment-modal-dark-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5); /* Dark translucent background */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1999; /* Below the main modal content */\n}\n\n.attachment-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  background-color: rgba(255, 255, 255, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000; /* Ensure it's on top of everything */\n}\n\n.attachment-modal-content-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 90vw;\n  max-height: 90vh;\n}\n\n.attachment-modal-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.attachment-modal-close-btn {\n  position: fixed;\n  top: 15px;\n  right: 10px;\n  background-color: white;\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2001; /* Above the media content */\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n}\n\n.attachment-modal-close-btn i {\n  color: black;\n  font-size: 20px;\n}\n\n.attachment-modal-actions {\n  position: fixed;\n  top: 80px; /* Below the close button */\n  right: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  z-index: 2001;\n}\n\n.attachment-modal-action-btn {\n  background-color: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n  transition: background-color 0.2s ease;\n}\n\n.attachment-modal-action-btn i {\n  color: #333;\n  font-size: 18px;\n}\n\n.attachment-modal-react-icon {\n  width: 20px;\n  height: 20px;\n  filter: grayscale(100%);\n  opacity: 0.8;\n}\n\n.attachment-modal-emoji-picker-container {\n  position: fixed;\n  top: 210px;\n  right: 50px;\n  z-index: 2002; /* Above the modal overlay */\n}\n\n.attachment-modal-action-btn:hover {\n  background-color: white;\n}\n\n.attachment-modal-media-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative; /* For positioning reactions */\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.attachment-modal-media {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.attachment-modal-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* Align items to the left */\n  text-align: left;\n  margin-top: 16px;\n  color: #333;\n  width: 100%;\n}\n\n.attachment-modal-file-info {\n  font-weight: bold;\n  font-size: 16px;\n  color: black;\n}\n\n.attachment-modal-view-btn {\n  color: red;\n  text-decoration: none;\n}\n\n.attachment-modal-view-btn:hover {\n  opacity: 0.8;\n}\n\n.message-reactions.in-modal {\n  position: absolute;\n  bottom: 5px;\n  left: -5px;\n  z-index: 1;\n}\n\n.attachment-modal-fallback-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  color: #888;\n  font-style: italic;\n  font-size: 16px;\n  width: 250px;\n  height: 150px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.attachment-modal-loading-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0,0,0,0.5);\n}\n\n.attachment-modal-loading-text {\n  font-size: 16px;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
